<div class="entity-list-container">
  <form [formGroup]="entityListForm">
    <mat-card class="no_box_shadow">
      <mat-card-content>

        <!-- Toolbar: page title + record count on the left, Create Entity on the right -->
        <div class="example-button-row">
          <div class="entity-toolbar-title">
            <span class="entity-toolbar-heading">Entities</span>
            <span class="entity-toolbar-count" *ngIf="totalRecords != null">{{totalRecords}} records</span>
          </div>
          <a class="__add_client" (click)="openEntityForm()">
            <mat-icon class="__icon">add_circle</mat-icon>
            Create Entity
          </a>
        </div>


        <!-- Entity Table -->
        <div class="table-wrapper">
          <table mat-table matSort [dataSource]="entityListDataSource"
                 multiTemplateDataRows (matSortChange)="sortData($event)">

            <!-- Expand chevron column -->
            <ng-container matColumnDef="expand">
              <th mat-header-cell *matHeaderCellDef class="header expand-col"></th>
              <td mat-cell *matCellDef="let element" class="expand-col">
                <button mat-icon-button (click)="toggleExpand(element, $event)"
                        [attr.aria-label]="element.id === expandedEntityId ? 'Collapse' : 'Expand'">
                  <mat-icon class="expand-icon" [class.expanded]="element.id === expandedEntityId">
                    chevron_right
                  </mat-icon>
                </button>
              </td>
            </ng-container>

            <!-- Entity Code -->
            <ng-container matColumnDef="code">
              <th mat-header-cell *matHeaderCellDef class="header" [class.sticky-header]="true">
                <div class="sorting_header">
                  <span class="table-header" mat-sort-header>Entity Code</span>
                  <input placeholder="Search code" aria-label="Search by entity code" matInput type="search"
                         autocomplete="off" formControlName="code" class="mat-input-custom">
                </div>
              </th>
              <td mat-cell *matCellDef="let element">{{element.code}}</td>
            </ng-container>

            <!-- Entity Name -->
            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef class="header">
                <div class="sorting_header">
                  <span class="table-header" mat-sort-header>Entity Name</span>
                  <input placeholder="Search name" aria-label="Search by entity name" matInput type="search"
                         autocomplete="off" formControlName="name" class="mat-input-custom">
                </div>
              </th>
              <td mat-cell *matCellDef="let element" class="entity-name-cell">{{element.name}}</td>
            </ng-container>

            <!-- Number Of Branch -->
            <ng-container matColumnDef="numberOfBranch">
              <th mat-header-cell *matHeaderCellDef class="header">
                <span class="table-header">No. of Branches</span>
              </th>
              <td mat-cell *matCellDef="let element" class="center-cell">
                <span class="branch-count-cell"
                      *ngIf="branchesMap.has(element.id); else apiCount">
                  {{getBranches(element.id).length}}
                </span>
                <ng-template #apiCount>
                  <span class="branch-count-cell" *ngIf="element.numberOfBranch != null">
                    {{element.numberOfBranch}}
                  </span>
                  <span *ngIf="element.numberOfBranch == null">-</span>
                </ng-template>
              </td>
            </ng-container>

            <!-- City -->
            <ng-container matColumnDef="city">
              <th mat-header-cell *matHeaderCellDef class="header">
                <div class="sorting_header">
                  <span class="table-header">City</span>
                  <input placeholder="Search city" aria-label="Search by city" matInput type="search"
                         autocomplete="off" formControlName="city" class="mat-input-custom">
                </div>
              </th>
              <td mat-cell *matCellDef="let element">{{element.city || '-'}}</td>
            </ng-container>

            <!-- Country -->
            <ng-container matColumnDef="country">
              <th mat-header-cell *matHeaderCellDef class="header">
                <span class="table-header">Country</span>
              </th>
              <td mat-cell *matCellDef="let element">{{element.countryName || '-'}}</td>
            </ng-container>

            <!-- Status -->
            <ng-container matColumnDef="status">
              <th mat-header-cell *matHeaderCellDef class="header">
                <span class="table-header">Status</span>
              </th>
              <td mat-cell *matCellDef="let element">
                <span class="status-pill"
                      [ngClass]="getStatusLabel(element) === 'Deactivation Approval Pending' ? 'status-deactivation-pending' : getStatusClass(element.status)">
                  {{getStatusLabel(element)}}
                </span>
              </td>
            </ng-container>

            <!-- Actions -->
            <ng-container matColumnDef="action">
              <th mat-header-cell *matHeaderCellDef class="header">
                <span class="table-header">Actions</span>
              </th>
              <td mat-cell *matCellDef="let element" class="__action_row">
                <div class="__action_group">
                  <button type="button" class="__action_edit_icon" matTooltip="Edit" aria-label="Edit entity"
                          (click)="openEntityForm(element.id); $event.stopPropagation()">
                    <mat-icon>create</mat-icon>
                  </button>
                  <button type="button" class="__action_view_icon" matTooltip="View" aria-label="View entity"
                          (click)="openEntityView(element.id); $event.stopPropagation()">
                    <mat-icon>visibility</mat-icon>
                  </button>
                </div>
              </td>
            </ng-container>

            <!-- Expandable detail row (full-width branch panel) -->
            <ng-container matColumnDef="expandedDetail">
              <td mat-cell *matCellDef="let element" [attr.colspan]="entityColumns.length" class="detail-cell">
                <div class="branch-panel" *ngIf="element.id === expandedEntityId">

                  <div class="branch-panel-header">
                    <span class="branch-panel-title">BRANCH DETAILS</span>
                    <span class="branch-count-badge">{{getBranches(element.id).length}}</span>
                  </div>

                  <!-- Loading -->
                  <div *ngIf="isBranchLoading(element.id)" class="branch-loading">
                    <mat-spinner diameter="30"></mat-spinner>
                  </div>

                  <!-- Branch cards grid -->
                  <div class="branch-cards-grid" *ngIf="!isBranchLoading(element.id)">
                    <div class="branch-card"
                         *ngFor="let branch of getBranches(element.id)"
                         [class.branch-card--selected]="false">

                      <div class="branch-card-top">
                        <div class="branch-card-main">
                          <div class="branch-card-header">
                            <span class="branch-name" [matTooltip]="branch.name">{{branch.name}}</span>
                          </div>

                          <div class="branch-card-address">
                            <mat-icon class="addr-icon">place</mat-icon>
                            <span>{{getBranchAddress(branch)}}</span>
                          </div>
                        </div>

                        <div class="branch-card-side">
                          <span class="branch-code-badge" [matTooltip]="branch.code" matTooltipPosition="above">{{branch.code}}</span>
                          <!-- Contact Details button — visible to anyone with Entity view permission -->
                          <button *ngIf="viewPermission"
                                  mat-icon-button color="primary" type="button"
                                  matTooltip="View Contact Details"
                                  (click)="openBranchContactDialog(branch, element); $event.stopPropagation()">
                            <mat-icon class="contact-icon">contacts</mat-icon>
                          </button>
                        </div>
                      </div>

                      <div *ngIf="branch.status === 'DEACTIVATED'" class="branch-status-deactivated-badge">
                        Deactivated
                      </div>

                      <div *ngIf="branch.sez" class="sez-badge">
                        <mat-icon class="sez-star-icon">star</mat-icon> SEZ
                      </div>

                    </div>

                    <div *ngIf="getBranches(element.id).length === 0" class="no-branches">
                      No branches found.
                    </div>
                  </div>

                </div>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="entityColumns; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: entityColumns;"
                class="entity-row" (click)="toggleExpand(row, $event)"></tr>
            <tr mat-row *matRowDef="let row; columns: ['expandedDetail']"
                class="detail-row"></tr>

          </table>
        </div>

      </mat-card-content>
    </mat-card>

    <mat-paginator [pageSizeOptions]="pageSizeOptions" [pageSize]="pageSize" [length]="totalRecords"
                   showFirstLastButtons></mat-paginator>
  </form>
</div>
